// Di dalam app Capacitor (apps/android-shell) root "/" bukan halaman marketing —
// shell load server.url tanpa path, jadi landing harus langsung lempar ke gate /home.
// Guard di runtime, bukan di capacitor.config, supaya app yang sudah ter-install
// ikut kena tanpa perlu rebuild APK.
"use client";

import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { isNativeApp } from "@/lib/native-bridge";

export function NativeRedirect() {
  const router = useRouter();

  useEffect(() => {
    if (isNativeApp()) router.replace("/home");
  }, [router]);

  return null;
}
